import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Button from "@mui/material/Button";
import './CurrencySelector.css';

/**
 * Affiche la devise courante et permet d'en choisir une autre si disponible.
 * @param {object} props
 * @param {string[]} props.currencies
 * @param {string} [props.value]
 * @param {string} [props.defaultValue]
 * @param {(currencyCode: string) => void} [props.onCurrencySelection]
 * @param {boolean} [props.isDarkStyle]
 * @param {string} [props.className]
 */
export default function CurrencySelector(props) {
    const [internalValue, setInternalValue] = React.useState(props.defaultValue ? props.defaultValue : "EUR");
    const [anchorEl, setAnchorEl] = React.useState(null);
    const value = props.value || internalValue;

    const handleClick = event => {
        const anchor = document.querySelector( `div.search` );
        if( anchor ) {
            setAnchorEl( anchor );
        }
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    let css = "CurrencySelector-root";
    let cssSelect = "CurrencySelector-Label";
    let cssLabel = "CurrencySelector-Select";
    let cssMenu = "p-0";
    let cssContent = "dropdown-menu-md overflow-hidden p-3 Menu-CashMonitor-Popup";
    let cssPaper = "";

    if (props.isDarkStyle) {
        css += " dark";
        cssSelect += " dark";
        cssLabel += " dark";
        cssContent += " dark";
        cssPaper += " dark";
    }

    if (props.className) {
        css += " " + props.className;
    }

    /** @param {string} code */
    const renderCurrencySymbol = code => {
        switch ( code ) {
            case 'EUR':
                return <FontAwesomeIcon key={code} icon="fa-solid fa-euro-sign" />;
            case 'USD':
                return <FontAwesomeIcon key={code} icon="fa-solid fa-dollar-sign" />;
            case 'JPY':
            case 'YEN':
                return <FontAwesomeIcon key={code} icon="fa-solid fa-yen-sign" />;
            case 'GBP':
            case 'GPD':
                return <FontAwesomeIcon key={code} icon="fa-solid fa-sterling-sign" />;
            case 'ILS':
                return <FontAwesomeIcon key={code} icon="fa-solid fa-shekel-sign" />;
            case 'XPF':
                return 'XPF';
            case 'CHF':
                return 'CHF';
            default:
                return code;
        }
    };

    const currency = renderCurrencySymbol( value );
    if( props.currencies.length < 2 ) {
        return null;
    }
    return (
        <div className={css}>
            <IconButton className="Icon" color="inherit" disableRipple onClick={handleClick}>
                {currency}
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                keepMounted
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={Boolean(anchorEl)}
                classes={{ list: cssMenu, paper: cssPaper }}
                onClose={handleClose}
            >
                <div className={cssContent}>
                    <div className="grid-menu grid-menu-1col">
                        {
                            props.currencies.map( currencyCode => <Button key={`btn-${currencyCode}`}
                                                                          variant="text"
                                                                          className="Item hydrated compact"
                                                                          disableRipple
                                                                          onClick={evt => {
                                                                              setInternalValue( currencyCode );
                                                                              if( props.onCurrencySelection ) {
                                                                                  props.onCurrencySelection( currencyCode );
                                                                              }
                                                                              handleClose();
                                                                          }} >
                                {renderCurrencySymbol( currencyCode )}
                            </Button> )
                        }
                    </div>
                </div>
            </Menu>
        </div>
    );
}
